const entitiesRoute = {
	name: 'entities',
	path: 'entities',
	meta: {
		title: 'Entidades',
	},
	component: () => import('@/pages/configuration/page-entities'),
};

export default entitiesRoute;



// WEBPACK FOOTER //
// ./src/router/configuration/entities/index.js